/**
 * Created by lihanying on 2017/6/23.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { postData } from '../../util/index'
import { message } from 'antd'
import { CLUB_ID } from '../ClubBusiness/constants'

export function fetchSendVerifyCode(phone, region) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/LoginApi/sendVerify` //sendVerifyCode
    return postData(
      endpoint,
      'POST',
      JSON.stringify({
        phone,
        region,
        shxt: sessionStorage.getItem('shxt'),
      })
    ).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

export function fetchBinding(phone, captcha, region) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/LoginApi/firstLogin`
    return postData(
      endpoint,
      'POST',
      JSON.stringify({
        code: captcha,
        phone,
        region,
        shxt: sessionStorage.getItem('shxt'),
      })
    ).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        window.location.href = '/home/Homepage'
        sessionStorage.setItem('user_account', data.list.account)
        sessionStorage.setItem('club_name', data.list.club_name)
        sessionStorage.setItem(CLUB_ID, data.list.club_id)
        sessionStorage.setItem('role_id', data.list.role_id)
        sessionStorage.setItem('user_nickname', data.list.nickname)
        sessionStorage.setItem('headimgurl', data.list.headimgurl)
      } else {
        message.error(data.detail)
      }
    })
  }
}

//获取地区列表
export function fetRegionList(cb) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/LoginApi/regionList`
    return postData(endpoint, 'POST').then((data) => {
      cb(data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/Binding/action.js